import {Observable} from 'rxjs';
import {educatAPI, RestQueryParams} from 'educat-common-web';


export function updateUserActiveStatusAPI(authToken: string, userId: string): Observable<any> {
    return educatAPI.get(
        `users/${userId}/active_status`,
        new RestQueryParams(),
        {
            Authorization: `Bearer ${authToken}`
        }
    );
}
